import {
    CardActionArea,
    CircularProgress,
    ClickAwayListener,
    Divider,
    Icon,
    Modal, styled,
    SwipeableDrawer, tableRowClasses
} from "@mui/material";
import OutlinedInput from '@mui/material/OutlinedInput';
import MiscellaneousServicesIcon from '@mui/icons-material/MiscellaneousServices';
import getLPTheme from '../getLPTheme';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import { WheelPicker, WheelPickerWrapper } from '@ncdai/react-wheel-picker';
import '@ncdai/react-wheel-picker/style.css';
import FilterListIcon from '@mui/icons-material/FilterList';
import App from './App';
import AddIcon from '@mui/icons-material/Add';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import { useMediaQuery } from "@mui/material";
import { useTheme } from "@mui/material";
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import PersonIcon from '@mui/icons-material/Person';
import Badge from '@mui/material/Badge';
import { AdapterLuxon } from '@mui/x-date-pickers/AdapterLuxon';
import { DateTime } from 'luxon';
import MenuItem from '@mui/material/MenuItem';
import dayjs, { Dayjs } from 'dayjs';
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import { default as FilterInfo} from './Info';
import { default as FilterInfoV2} from './InfoV2';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import Select from '@mui/material/Select';
import ItemsListV2 from './ItemsListV2';
import Link from '@mui/material/Link';
import {useContext, useEffect, useState, useRef} from 'react';
import {SvgIcon} from "@mui/material";
import InfoSmall from './InfoSmall';

import {AuthContext} from "../index";
import {GlobalDataContext} from "../index";
import {useLocation, useNavigate, useParams, useSearchParams} from "react-router-dom";
import axios from "axios";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";
import Stack from "@mui/material/Stack";
import {compareDesc} from "date-fns";
import Container from "@mui/material/Container";

import { LOCATIONS } from '../data/database';
import {LocalizationProvider, StaticDatePicker, StaticTimePicker, TimeField} from "@mui/x-date-pickers";
import {grey} from "@mui/material/colors";

import './AppScreen.css';
import AuthBySMSInfoSmall from './AuthBySMSInfoSmall';
import {LocalHospital} from "@mui/icons-material";
import ItemsList from './ItemsList';
import getImage from '../utils/getImage';
import Info from './Info';
import {default as PickedServiceInfo } from './Info';
import {default as AddEmptyServiceInfo } from './Info';
import {default as AddServiceInfo} from './InfoV2';
import { getHour, getDay, getWeekday, getDateString, getHourMinutes } from '../utils/dateTime';
import {createTheme, ThemeProvider} from "@mui/material/styles";
import React from "react";

const HOUR_OPTIONS = Array.from({ length: 11 }, (_, i) => {
    const value = i + 10;
    return { value, label: value.toString().padStart(2, '0') };
});

const MINUTE_OPTIONS = [0, 15, 30, 45].map(value => ({
    value,
    label: value.toString().padStart(2, '0')
}));

const TIME_WHEEL_CLASS_NAMES = {
    optionItem: 'time-wheel-option',
    highlightWrapper: 'time-wheel-highlight'
};

function AppScreen() {
    const calendarButtonRef = useRef(null);
    const { userId, phoneNumber, onLogin, onLogout } = useContext(AuthContext);
    // const { gsFilters, setGSFilters } = useContext(GlobalDataContext);
    const { pathname } = useLocation();
    const navigate = useNavigate();

    const fillById = (id, arr = []) => {
        const ix = arr.findIndex(it => it.id == id);
        if (ix != -1) {
            return arr[ix];
        }

        return { id };
    }

    const fillByMappedId = (id, arr = [], provider) => {
        const ix = arr.findIndex(it => provider(it) == id);
        if (ix != -1) {
            return arr[ix];
        }

        return { id };
    }

    const getValueFromFilter = (type, filters) => {
        if (!filters || !filters.filter(f => f.type == type).length) {
            return null;
        }

        return filters.filter(f => f.type == type)[0].value;
    }

    const [filters, setFilters] = useState([]);

    const DEFAULT_FILTER_INFO_STATE = {
        open: false,
        calendar: {}
    };

    const DEFAULT_FILTER_INFO_STATE_V2 = {
        open: false,
        filters: [ ...filters]
    }
    const [filterInfo, setFilterInfo] = useState(DEFAULT_FILTER_INFO_STATE_V2)

    const [ specialistServices, setSpecialistServices ] = useState({
        isLoaded: false, data: []
    });
    const [specialists, setSpecialists] = useState({ isLoaded: false, data: []});

    async function loadSpecialists() {
        try {
            const resp = await axios.post(`/api/v1/specialists/get-specialists`);

            setSpecialists({isLoaded: true, data: resp.data});
        } catch (err) {
            //noop
        }
    }

    const [locations, setLocations] = useState({isLoaded: false, data: []})

    async function loadLocations() {
        try {
            const resp = await axios.get(`/api/v1/locations`);
            setLocations({isLoaded: true, data: resp.data});
        } catch (err) {
            //noop
        }
    }

    const [serviceTemplates, setServiceTemplates] = useState({isLoaded: false, data: []});
    async function _loadServiceTemplates() {
        try {
            const resp = await axios.get(`/api/v1/services/templates`);
            setServiceTemplates({isLoaded: true, data: resp.data});
        } catch (err) {
            //noop
        }
    }

    useEffect(() => {
        if (userId && !serviceTemplates.isLoaded) {
            _loadServiceTemplates();
        }
    }, [userId, serviceTemplates.isLoaded]);

    useEffect(() => {
        if (userId && !specialists.isLoaded) {
            loadSpecialists();
        }
    }, [userId, specialists.isLoaded]);

    useEffect(() => {
        if (userId && !locations.isLoaded) {
            loadLocations();
        }
    }, [userId, locations.isLoaded]);


    async function loadServices() {
        try {
            const [ serviceTemplates, allLocations, specialists ] = await Promise.all([loadServiceTemplates(), loadAllLocations(), loadSpecialistsV2()]);

            const resp = await axios.post(`/api/v1/services/get`, {
                specialistIds: getValueFromFilter('specialist', filters) ? [getValueFromFilter('specialist', filters)] : ['00000000-0000-0000-0000-000000000000']
            });

            const services = resp.data.map(it => {
                it.locaction = fillById(it?.location?.id, allLocations);
                it.serviceTemplate = fillById(it?.serviceTemplate?.id, serviceTemplates);
                it.specialist = fillByMappedId(it?.specialist?.id, specialists, (it) => it?.id);

                return it;
            })

            setSpecialistServices({isLoaded: true, data: services});

        } catch (err) { throw err; }
    }

    async function loadAllLocations() {
        let url = `/api/v1/locations`;
        try {
            const resp = await axios.get(url);
            return resp.data;
        } catch (err) { throw err; }

    }
    async function loadSpecialistsV2() {
        try {
            const resp = await axios.post(`/api/v1/specialists/get-specialists`);

            return resp.data;
        } catch (err) {
            //noop
        }
    }

    async function loadServiceTemplates() {
        let url = `/api/v1/services/templates`;
        try {
            const resp = await axios.get(url);
            return resp.data;
        } catch (err) { throw err; }
    }

    useEffect(() => {
        if (userId && !specialistServices.isLoaded) {
            loadServices();
        }
    }, [userId, specialistServices.isLoaded]);

    const DEFAULT_NEW_SERVICE_STATE = {
        open: false,
        calendar: {
            open: false,
            date: DateTime.now(),
        },
        time: {
            open: false,
            from: DateTime.now().set({ hour: '10', minute: '00' }),
            to: DateTime.now().set({ hour: '20', minute: '00' })
        },
        specialist: {
            id: ''
        },
        location: {
            id: ''
        },
        serviceTemplate: {
            id: ''
        }
    };

    const [newService, setNewService] = useState(DEFAULT_NEW_SERVICE_STATE);

    const handleWheelTimeChange = (field, part) => (value) => {
        setNewService(ps => {
            const current = ps.time[field];
            if (!current) {
                return ps;
            }

            let next = current.set({ [part]: value });

            if (part === 'hour' && value === 20) {
                next = next.set({ minute: 0 });
            }

            if (part === 'minute' && next.hour === 20 && value !== 0) {
                return ps;
            }

            return {...ps, time: {...ps.time, [field]: next}};
        });
    };

    const _handleAddNewService = () => {
        setNewService(prevState => ({...prevState, open: true}));
    }

    const handleDeleteService = async (serviceId) => {
        try {
            const resp = await axios.delete(`/api/v1/services/${serviceId}`);
            loadServices();
        } catch (err) { throw err; }
    }

    const _handleNewServiceReset = () => {
        setNewService({...DEFAULT_NEW_SERVICE_STATE, open: true});
    }

    const _handleNewServiceCreate = () => {

        async function createNewService() {
            try {
                const resp = await axios.post(`/api/v1/services`, {
                    specialist: {
                        id: newService?.specialist?.id,
                    },
                    serviceTemplate: {
                        id: newService?.serviceTemplate?.id,
                    },
                    timeFrame: {
                        from: newService?.time?.from?.toUnixInteger(),
                        to: newService?.time?.to?.toUnixInteger()
                    },
                    location: {
                        id: newService?.location?.id
                    }
                });

                setNewService(DEFAULT_NEW_SERVICE_STATE);
                setSpecialistServices(prevState => ({...prevState, isLoaded: false}));

            } catch (err) { throw err; }
        }

        createNewService();
    }

    const _handleFilterModalClose = () => {
        setFilterInfo(prevState => ({...prevState, open: false}))
    }

    const _handleSetFilters = () => {
        setFilterInfo(prevState => ({...prevState, open: false }));
        setFilters([...filterInfo.filters]);
        setSpecialistServices(prevState => ({...prevState, isLoaded: false}));
    }

    const _handleRemoveClient = async (serviceId) => {
        try {
            const resp = await axios.put(`/api/v1/services`, {
                id: serviceId,
                client: null
            });
        } catch (err) {
            //noop
        }
    }

    const handleSpecialistFilterPick = (newSpecialist) => {

        setFilterInfo(prevState => {
            const nextFilters = [...prevState?.filters ?? []];
            const ix = nextFilters.findIndex(fltr => fltr.type == 'specialist');
            if (ix != -1) {
                nextFilters.splice(ix, 1);
            }

            return {
                ...prevState,
                filters: [...nextFilters, { type: 'specialist', value: newSpecialist }]
            }
        });
    }

    const [serviceDetailed, setServiceDetailed] = useState(null);

  return (
          <App
              withNavigation
              top={
                  <Stack spacing={3} direction='row'
                         sx={{
                             p: 2,
                             display: 'flex',
                             alignItems: 'center',
                             justifyContent: 'flex-start',
                             backgroundColor: '#fcfcfc',
                             flexGrow: 0,
                             boxShadow: 'rgba(50, 50, 93, 0.25) 0px 6px 12px -2px, rgba(0, 0, 0, 0.3) 0px 3px 7px -3px'
                         }}
                  >

                      <Badge badgeContent={ filters.length } color={"primary"} onClick={ () => {
                          setFilterInfo(prevState => ({...prevState, open: true}));
                      }}
                             sx={{
                                 '&:hover': { cursor: 'pointer'},
                                 borderRadius: '15px',
                                 p: '2px',
                                 border: "1px solid black"
                             }}
                      >
                          <FilterListIcon/>
                      </Badge>
                      <Stack spacing={2} direction='row' justifyContent='flex-end' alignItems='center'
                             sx={{
                                 flex: 1,
                                 flexGrow: 1,
                                 display: 'flex',
                                 justifyContent: 'flex-end',
                             }}
                      >
                          <AddIcon
                              sx={{
                                  m: 0,
                                  p: '3px',
                                  borderRadius: '20px',
                                  backgroundColor: '#A95C68',
                                  color: '#fff',
                                  display: { xs: 'block', sm: 'none'}
                              }}
                              onClick={ _handleAddNewService }
                          />
                      </Stack>
                  </Stack>
              }
          >
          <FilterInfoV2
              open={filterInfo.open}
              handleClose={_handleFilterModalClose}
          >
              <Stack
                  sx={{
                      height: '100%',
                      justifyContent: 'space-between'
                  }}
              >
                  <Box sx={{p: 2, pt: 4, pb: 4 }}>
                      <Typography align={'center'} sx={{fontWeight: 'bold', fontSize: '22px'}}>Фильтры</Typography>
                  </Box>
                  <Box sx={{overflowY: 'auto', height: '100%'}}>
                      <Stack direction={'row'}  alignItems={'center'}
                             sx={{
                                 pt: 1,
                                 pb: 1,
                                 pr: 1
                             }}
                      >
                          <PersonIcon sx={{p: 2, color: 'rgb(0 0 0/0.75)'}} />
                          <Stack direction={'row'}
                                 sx={{
                                     width: '100%',
                                     pb: 1,
                                     '&:hover': {
                                         cursor: 'pointer',
                                         backgroundColor: 'rgb(0 0 0 / 0.01)'
                                     },
                                 }}
                                 onClick={() => { }}
                                 alignItems={'center'} justifyContent={'space-between'}
                          >
                              <Stack
                                  sx={{width: '90%'}}
                              >
                                  <Typography fontSize={'12px'} sx={{color: 'rgb(0 0 0/ 0.7)'}} >Специалист</Typography>
                                  <Select
                                      value={ getValueFromFilter('specialist', filterInfo.filters) }
                                      onChange={(event) => { handleSpecialistFilterPick(event.target.value)} }
                                  >
                                      {specialists.data?.map((it) => (
                                          <MenuItem
                                              key={it?.firstName + " " + it?.lastName}
                                              value={ it?.id }
                                          >
                                              {it?.firstName + " " + it?.lastName }
                                          </MenuItem>
                                      ))}
                                  </Select>
                                  <Typography>
                                  </Typography>
                              </Stack>
                          </Stack>
                      </Stack>
                  </Box>
                          <Box sx={{ p: 2 }}>
                              <Stack direction={'row'} sx={{justifyContent: 'center'}} spacing={2}>
                                  <Button sx={{mt:4}} variant={'outlined'}
                                          onClick={() => { setFilterInfo(DEFAULT_FILTER_INFO_STATE)}}
                                          sx={{
                                              flex: '1 1 auto',
                                              maxWidth: '300px'
                                          }}
                                  >
                                      Сбросить
                                  </Button>
                                  <Button
                                      sx={{mt:4}} variant={'contained'}
                                      onClick={() => { _handleSetFilters() }}
                                      sx={{
                                          flex: '1 1 auto',
                                          maxWidth: '300px'
                                      }}
                                  >
                                      Применить
                                  </Button>
                            </Stack>
                          </Box>
              </Stack>
          </FilterInfoV2>
          <AddServiceInfo
              open={newService.open}
              handleClose={() => { setNewService(ps => ({...ps, open: false}))}}
          >
              <Stack
                  sx={{
                      height: '100%',
                      justifyContent: 'space-between'
                  }}
              >
                  <Box sx={{p: 2, pt: 4, pb: 4 }}>
                      <Typography align={'center'} sx={{fontWeight: 'bold', fontSize: '22px'}}>Новый сервис</Typography>
                  </Box>
                  <Box sx={{overflowY: 'auto', height: '100%'}}>
                      <Stack direction={'row'}  alignItems={'center'}
                             sx={{
                                 pt: 1,
                                 pb: 1,
                                 pr: 1
                             }}
                      >
                          <CalendarMonthIcon sx={{p: 2, color: 'rgb(0 0 0/0.75)'}} />
                          <Stack direction={'row'}
                                 sx={{
                                     width: '100%',
                                     pb: 1,
                                     '&:hover': {
                                         cursor: 'pointer',
                                         backgroundColor: 'rgb(0 0 0 / 0.01)'
                                     },
                                 }}
                                 onClick={() => { setNewService(ps => ({...ps, calendar: {...ps?.calendar, open: !ps?.calendar?.open}}))}}
                                 alignItems={'center'} justifyContent={'space-between'}
                          >
                              <Stack>
                                  <Typography fontSize={'12px'} sx={{color: 'rgb(0 0 0/ 0.7)'}} >Дата</Typography>
                                  <Typography>
                                      { getDay(newService?.calendar?.date) }
                                  </Typography>
                              </Stack>
                          </Stack>
                          <ArrowForwardIosIcon
                              onClick={() => { setNewService(ps => ({...ps, calendar: {...ps?.calendar, open: !ps?.calendar?.open}}))}}
                              sx={{
                                  p: 2,
                                  color: 'rgb(0 0 0/0.75)',
                                  fontSize: '16px',
                                  rotate: newService.calendar.open ? '90deg': 'none'
                              }}
                          />

                      </Stack>
                      { newService?.calendar?.open ?
                          <LocalizationProvider dateAdapter={AdapterLuxon} adapterLocale={'ru'}>
                              <StaticDatePicker
                                  onChange={(newDate) => {
                                      const from = newDate.set({hour: '10', minute:'00'});
                                      const to = newDate.set({hour: '20', minute: '00'});
                                      setNewService(ps => ({...ps, calendar: { ...ps?.calendar, open: false, date: newDate}, time: {from: from, to: to}})) }
                                  }
                                  onClose={() => { setNewService(ps => ({...ps, calendar: {...ps?.calendar, open: false }})); }}
                                  views={['month', 'day']}
                                  value={ newService?.calendar?.date }
                                  disablePast
                                  slotProps={{
                                      toolbar: {
                                          hidden: true
                                      }
                                  }}
                                  slots={{
                                      actionBar: () => null
                                  }}
                              />
                          </LocalizationProvider> : null
                      }
                      <Stack direction={'row'}  alignItems={'start'} justifyContent={'center'}
                             sx={{
                                 pt: 1,
                                 pb: 1,
                                 pr: 1
                             }}
                      >
                          <AccessTimeIcon sx={{p: 2, color: 'rgb(0 0 0/0.75)'}} />
                          <Stack
                              spacing={1}
                              direction={'row'}
                              sx={{
                                  width: '100%',
                                  pb: 1,
                                  pr: 6,
                                  '&:hover': {
                                      cursor: 'pointer',
                                      backgroundColor: 'rgb(0 0 0 / 0.01)'
                                  },
                              }}
                              alignItems={'center'} justifyContent={'space-between'}
                          >
                              <Stack>
                                  <Typography fontSize={'12px'} sx={{color: 'rgb(0 0 0/ 0.7)'}} >С</Typography>
                                  <LocalizationProvider dateAdapter={AdapterLuxon} adapterLocale={'ru'}
                                  >
                                      <TimeField
                                          value={ newService?.time?.from }
                                          readOnly={true}
                                          onClick={() => { setNewService(ps => ({...ps, time: {...ps?.time, open: !ps?.time?.open}}))}}
                                          // onChange={(newTime) => {
                                          //     setNewService(ps => ({...ps, time: {...ps.time, from: newTime}}))
                                          // }}
                                          size={'small'}
                                      />
                                      {
                                        newService?.time?.open ?
                                            <WheelPickerWrapper className={'time-wheel-wrapper'}>
                                                <WheelPicker
                                                    options={HOUR_OPTIONS}
                                                    value={newService?.time?.from?.hour ?? 10}
                                                    onValueChange={handleWheelTimeChange('from', 'hour')}
                                                    infinite
                                                    visibleCount={12}
                                                    classNames={TIME_WHEEL_CLASS_NAMES}
                                                />
                                                <WheelPicker
                                                    options={MINUTE_OPTIONS}
                                                    value={newService?.time?.from?.minute ?? 0}
                                                    onValueChange={handleWheelTimeChange('from', 'minute')}
                                                    infinite
                                                    visibleCount={12}
                                                    classNames={TIME_WHEEL_CLASS_NAMES}
                                                />
                                            </WheelPickerWrapper> : null
                                      }
                                  </LocalizationProvider>
                              </Stack>
                              <Stack>
                                  <Typography fontSize={'12px'} sx={{color: 'rgb(0 0 0/ 0.7)'}} >По</Typography>
                                  <LocalizationProvider dateAdapter={AdapterLuxon} adapterLocale={'ru'}>
                                      <TimeField
                                          value={ newService?.time?.to }
                                          readOnly={true}
                                          onClick={() => { setNewService(ps => ({...ps, time: {...ps?.time, open: !ps?.time?.open}}))}}
                                          // onChange={(newTime) => {
                                          //     setNewService(ps => ({...ps, time: {...ps.time, to: newTime}}))
                                          // }}
                                          size={'small'}
                                      />
                                      {
                                          newService?.time?.open ?
                                              <WheelPickerWrapper className={'time-wheel-wrapper'}>
                                                  <WheelPicker
                                                      options={HOUR_OPTIONS}
                                                      value={newService?.time?.to?.hour ?? 20}
                                                      onValueChange={handleWheelTimeChange('to', 'hour')}
                                                      infinite
                                                      visibleCount={12}
                                                      classNames={TIME_WHEEL_CLASS_NAMES}
                                                  />
                                                  <WheelPicker
                                                      options={MINUTE_OPTIONS}
                                                      value={newService?.time?.to?.minute ?? 0}
                                                      onValueChange={handleWheelTimeChange('to', 'minute')}
                                                      infinite
                                                      visibleCount={12}
                                                      classNames={TIME_WHEEL_CLASS_NAMES}
                                                  />
                                              </WheelPickerWrapper> : null
                                      }
                                  </LocalizationProvider>
                              </Stack>
                          </Stack>
                          <ArrowForwardIosIcon
                              onClick={() => { setNewService(ps => ({...ps, time: {...ps?.time, open: !ps?.time?.open}}))}}
                              sx={{
                                  p: 2,
                                  mt:2,
                                  color: 'rgb(0 0 0/0.75)',
                                  fontSize: '16px',
                                  rotate: newService.time.open ? '90deg': 'none'
                              }}
                          />
                      </Stack>
                      <Box>
                          <Stack direction={'row'}  alignItems={'center'}
                                 sx={{
                                     pt: 1,
                                     pb: 1,
                                     pr: 1
                                 }}
                          >
                              <PersonIcon sx={{p: 2, color: 'rgb(0 0 0/0.75)'}} />
                              <Stack direction={'row'}
                                     sx={{
                                         width: '100%',
                                         // borderBottom: '1px solid rgb(0 0 0 / 0.1)',
                                         pb: 1,
                                         '&:hover': {
                                             cursor: 'pointer',
                                             backgroundColor: 'rgb(0 0 0 / 0.01)'
                                         },
                                     }}
                                     onClick={() => { }}
                                     alignItems={'center'} justifyContent={'space-between'}
                              >
                                  <Stack
                                      sx={{width: '90%'}}
                                  >
                                      <Typography fontSize={'12px'} sx={{color: 'rgb(0 0 0/ 0.7)'}} >Специалист</Typography>
                                      <Select
                                          value={ newService?.specialist?.id }
                                          onChange={(event) => {
                                              setNewService(prevState => ({...prevState, specialist: { id: event.target.value}}));}
                                          }
                                          input={<OutlinedInput/>}
                                      >
                                          {specialists.data?.map((it) => (
                                              <MenuItem
                                                  key={it.firstName + " " + it.lastName}
                                                  value={ it?.id }
                                              >
                                                  {it.firstName + " " + it.lastName}
                                              </MenuItem>
                                          ))}
                                      </Select>
                                  </Stack>
                              </Stack>
                          </Stack>
                      </Box>
                      <Box>
                          <Stack direction={'row'}  alignItems={'center'}
                                 sx={{
                                     pt: 1,
                                     pb: 1,
                                     pr: 1
                                 }}
                          >
                              <MiscellaneousServicesIcon sx={{p: 2, color: 'rgb(0 0 0/0.75)'}} />
                              <Stack direction={'row'}
                                     sx={{
                                         width: '100%',
                                         pb: 1,
                                         '&:hover': {
                                             cursor: 'pointer',
                                             backgroundColor: 'rgb(0 0 0 / 0.01)'
                                         },
                                     }}
                                     onClick={() => { }}
                                     alignItems={'center'} justifyContent={'space-between'}
                              >
                                  <Stack
                                      sx={{width: '90%'}}
                                  >
                                      <Typography fontSize={'12px'} sx={{color: 'rgb(0 0 0/ 0.7)'}} >Сервис темплейт</Typography>
                                      <Select
                                          value={ newService?.serviceTemplate?.id }
                                          onChange={(event) => {
                                              setNewService(prevState => ({...prevState, serviceTemplate: { id: event.target.value }}))
                                          }}
                                          input={<OutlinedInput/>}
                                      >
                                          {serviceTemplates?.data?.map((it) => (
                                              <MenuItem
                                                  key={ it?.title}
                                                  value={ it?.id }
                                              >
                                                  {it?.title}
                                              </MenuItem>
                                          ))}
                                      </Select>
                                  </Stack>
                              </Stack>
                          </Stack>
                      </Box>
                      <Box>
                          <Stack direction={'row'}  alignItems={'center'}
                                 sx={{
                                     pt: 1,
                                     pb: 1,
                                     pr: 1
                                 }}
                          >
                              <LocationOnIcon sx={{p: 2, color: 'rgb(0 0 0/0.75)'}} />
                              <Stack direction={'row'}
                                     sx={{
                                         width: '100%',
                                         // borderBottom: '1px solid rgb(0 0 0 / 0.1)',
                                         pb: 1,
                                         '&:hover': {
                                             cursor: 'pointer',
                                             backgroundColor: 'rgb(0 0 0 / 0.01)'
                                         },
                                     }}
                                     onClick={() => { }}
                                     alignItems={'center'} justifyContent={'space-between'}
                              >
                                  <Stack
                                      sx={{width: '90%'}}
                                  >
                                      <Typography fontSize={'12px'} sx={{color: 'rgb(0 0 0/ 0.7)'}} >Локация</Typography>
                                      <Select
                                          value={ newService?.location?.id }
                                          onChange={(event) => {
                                              setNewService(prevState => ({...prevState, location: { id: event.target.value }}));
                                          }}
                                          input={<OutlinedInput/>}
                                      >
                                          {locations?.data?.map((it) => (
                                              <MenuItem
                                                  key={it?.title}
                                                  value={ it?.id }
                                              >
                                                  {it?.title}
                                              </MenuItem>
                                          ))}
                                      </Select>
                                  </Stack>
                              </Stack>
                          </Stack>
                      </Box>
                  </Box>
                          <Box sx={{ p: 2 }}>
                              <Stack direction={'row'} sx={{justifyContent: 'center'}} spacing={2}>
                                  <Button sx={{mt:4, width: '100%'}} variant={'outlined'}
                                          onClick={ _handleNewServiceReset }
                                          sx={{
                                              flex: '1 1 auto',
                                              maxWidth: '300px'
                                          }}
                                  >
                                      Сбросить
                                  </Button>
                                  <Button sx={{mt:4, width: '100%'}} variant={'contained'}
                                          onClick={ _handleNewServiceCreate }
                                          sx={{
                                              flex: '1 1 auto',
                                              maxWidth: '300px'
                                          }}
                                  >
                                      Добавить
                                  </Button>
                              </Stack>
                          </Box>
              </Stack>
          </AddServiceInfo>
          <Grid container
                spacing={1}
                justifyContent="flex-start"
                alignItems="flex-start"
          >

                  <Grid item md={3} lg={2} xs={12}
                        sx={{
                            height: '100%',
                            m: {xs: 1},
                        }}>
                      <Box>
                          {

                              specialistServices.data
                                  .sort((left, right) => left?.timeFrame?.from - right?.timeFrame?.from)
                                  .reduce((acc, curr) => {
                                      //todo: change
                                  const dayString =  getDateString(DateTime.fromSeconds(curr.timeFrame.from));
                                  const dayStringFormatted = getWeekday(curr.timeFrame.from) + " - " + getDay(curr.timeFrame.from)
                                  const idx = acc.findIndex(it => it.dayString == dayString);

                                  if (idx != -1) {
                                    acc[idx].data.push(curr);
                                  } else {
                                      acc.push({
                                          dayStringFormatted: dayStringFormatted,
                                          dayString: dayString,
                                          data: [curr]
                                      })
                                  }

                                  return acc;
                              }, [])
                                  .map(sg => (
                                  <>
                                      <Typography align={'left'} fontSize={"20px"}>{sg.dayStringFormatted}</Typography>
                                      <ItemsListV2
                                          itemsLoading={ false }
                                          closeDetailed={ () => { setServiceDetailed(null)  }}
                                          items={ sg?.data?.length ? sg.data.map(item =>
                                              (
                                                  <Card
                                                      elevation={1}
                                                      sx={{display: 'flex', '&:hover':  { border: '1px solid #2999ff'}, '&:focus': {outline: 'none'}}}
                                                      onClick={() => { setServiceDetailed(item); } }
                                                  >
                                                      <CardActionArea
                                                          disableRipple
                                                          sx={{display: 'flex', justifyContent: 'flex-start', alignItems: 'flex-start'}}
                                                          onClick={() => { setServiceDetailed(item); } }
                                                      >
                                                          {
                                                              item?.serviceTemplate?.id ?
                                                                  <CardMedia
                                                                      component="img"
                                                                      sx={{ width: 100, height: 100, p: 1, borderRadius: '15px'}}
                                                                      image={  getImage(item?.serviceTemplate?.images?.map(im => im.id)) }
                                                                      alt=""
                                                                  /> : null
                                                          }
                                                          <CardContent
                                                              sx={{
                                                                  display: 'flex',
                                                                  flexDirection: 'column',
                                                                  justifyContent: 'flex-start',
                                                                  height: '100%',
                                                                  width: '100%'
                                                              }}
                                                          >
                                                              {
                                                                  item?.specialist?.id ?
                                                                      <Typography sx={{fontSize: '16px'}} align={'left'}> {`Специалист: ${item?.specialist?.firstName} ${item?.specialist?.lastName}` }</Typography> : null
                                                              }
                                                              {
                                                                  item?.serviceTemplate?.id ?
                                                                      <Typography sx={{fontSize: '16px'}} align={'left'}> {` ${item?.serviceTemplate?.title}: ${getHourMinutes(item?.timeFrame?.from)} - ${getHourMinutes(item?.timeFrame?.to)}` }</Typography>
                                                                      : <Typography sx={{fontSize: '16px'}} align={'left'}> { `Рабочее время: ${getHourMinutes(item?.timeFrame?.from)} - ${getHourMinutes(item?.timeFrame?.to)}` } </Typography>
                                                              }
                                                              {

                                                                  item?.serviceTemplate?.id ?
                                                                      item?.client?.id ?
                                                                          <Typography align={'left'} fontSize={'14px'}> Занято </Typography>
                                                                          : <Typography align={'left'} fontSize={'14px'}> Без клиента </Typography>
                                                                      : null
                                                              }
                                                          </CardContent>
                                                      </CardActionArea>
                                                  </Card>
                                              )) : (
                                              <Typography sx={{ color: 'gray', fontSize: '14px'}}>
                                                  Сервисов для указанных фильтров не найдено
                                              </Typography>
                                          )
                                          }
                                          itemDetailed={
                                              serviceDetailed ?
                                                  <Card
                                                      elevation={1}
                                                      sx={{display: 'block', minHeight: '100vh'}}
                                                  >
                                                      <Box
                                                          sx={{ minHeight: '100vh'}}
                                                      >
                                                          <CardMedia
                                                              sx={{ height: '200px'}}
                                                              component="img"
                                                              image={ getImage(serviceDetailed?.serviceTemplate?.images?.map(im => im.id)) }
                                                              alt=""
                                                          />
                                                          <CardContent>
                                                              <Typography align='left' sx={{pb: 2, fontSize: '18px'}}> { serviceDetailed?.serviceTemplate?.title } </Typography>
                                                              <Typography sx={{fontSize: '12px'}} align='left'> { serviceDetailed?.serviceTemplate?.description } </Typography>
                                                              <Typography sx={{pt: 2}} align={'left'}>Место и время</Typography>
                                                              <Stack sx={{justifyContent: 'flex-end'}} spacing={1}>
                                                                  <Typography sx={{pb: 1}}>{
                                                                      `${getDay(serviceDetailed?.timeFrame?.from) + " с " + getHourMinutes(serviceDetailed?.timeFrame?.from) + " по " + getHourMinutes(serviceDetailed?.timeFrame?.to)}`
                                                                  }</Typography>
                                                                  <Button
                                                                      variant={'contained'}
                                                                      onClick={() => {
                                                                          setServiceDetailed(null);
                                                                          handleDeleteService(serviceDetailed?.id)
                                                                      }}
                                                                  >
                                                                      Отменить слот
                                                                  </Button>
                                                                  {
                                                                      serviceDetailed?.client?.id ?
                                                                          <Button variant={'contained'}
                                                                                  onClick={() => {
                                                                                      _handleRemoveClient(serviceDetailed?.id);
                                                                                  }}
                                                                          >
                                                                              Отменить клиента
                                                                          </Button>
                                                                          : null
                                                                  }
                                                              </Stack>
                                                          </CardContent>
                                                      </Box>
                                                  </Card> : null
                                          }
                                      />
                                  </>
                              ))
                          }
                      </Box>
                  </Grid>
          </Grid>
      </App>
  );
}

export default AppScreen;
